import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import FAQsSection from "./HomeScreen/FAQsSection";
import ProductTourHeader from "./ProductTourHeader";
import { BASE_URL } from "../components/BASE_URL";

const DEFAULT_VIDEO_URL =
  "https://drive.google.com/file/d/1aEjz47tvkGa2Aho6hYHDJxvvZt_D_Sn7/preview";

const ProductTourPage = () => {
  const { i18n } = useTranslation();
  const [videoUrl, setVideoUrl] = useState(DEFAULT_VIDEO_URL);

  useEffect(() => {
    fetch(
      `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Product_Tour`
    )
      .then((res) => res.json())
      .then((json) => {
        const section = json?.data?.find(
          (sec) => sec?.name?.trim().toLowerCase() === "product_tour"
        );

        if (section?.items?.length) {
          const selectedItem =
            i18n.language === "es"
              ? section.items.find((item) => item.idx === 1)
              : section.items.find((item) => item.idx === 0);

          if (selectedItem?.url) {
            setVideoUrl(selectedItem.url);
          }
        }
      })
      .catch(() => {
        setVideoUrl(DEFAULT_VIDEO_URL);
      });
  }, [i18n.language]);

  return (
    <Box>
      <ProductTourHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Box
          sx={{
            width: { xs: "95%", sm: "85%", md: "70%", lg: "60%" },
            maxWidth: "960px",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "100%",
              paddingTop: "56.25%",
              borderRadius: { xs: "8px", md: "12px" },
              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
            }}
          >
            <iframe
              src={videoUrl}
              title="Product tour video"
              allow="autoplay"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "12px",
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: "white", pb: { xs: 2, md: 4 } }}>
        <FAQsSection />
      </Box>
    </Box>
  );
};

export default ProductTourPage;
